import { FunctionComponent } from "react";
import { darken, makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles<Theme, ICircleColorIconProps>((theme: Theme) => ({
  circle: {
    height: 15,
    width: 15,
    backgroundColor: ({ color }) => color,
    fontSize: 10,
    fontWeight: 700,
    color: "white",
    textAlign: "center",
    borderRadius: "50%",
    display: "inline-block",
    transition: "background-color 0.1s linear",
    "&:hover": {
      backgroundColor: ({ darkenOnHover, color }) => (darkenOnHover ? darken(color, 0.2) : color),
    },
  },
}));

interface ICircleColorIconProps {
  color: string;
  darkenOnHover?: boolean;
}

export const CircleColorIcon: FunctionComponent<ICircleColorIconProps> = (props) => {
  const { color, darkenOnHover, children } = props;
  const classes = useStyles({ color, darkenOnHover });

  return <span className={classes.circle}>{children}</span>;
};
